import { Link } from 'react-router-dom';
import { formatDateTime } from '@shared/format';
import { useDataset } from '../hooks/useDataset';
import { SITE_EMAIL } from '../site';
import { ExternalLink } from './ExternalLink';
import styles from './Footer.module.css';

export function Footer() {
    const { dataset } = useDataset();
    return (
        <footer className={styles.footer}>
            <ul className={styles.links}>
                <li>
                    <Link to="/">Accueil</Link>
                </li>
                <li>
                    <ExternalLink href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</ExternalLink>
                </li>
                <li>
                    <Link to="/à-propos/">Sources des données – Mentions légales</Link>
                </li>
            </ul>
            <p className={styles.meta}>
                Mise à jour des sentiers ONF le{' '}
                <span data-testid="last-onf-update">{dataset ? formatDateTime(dataset.lastUpdate) : '…'}</span>
                <br />
                <br />
                Un projet conçu et réalisé par <ExternalLink href="https://www.sys-dev-run.fr/">SysDevRun</ExternalLink>
            </p>
        </footer>
    );
}
